class ShippingProtection extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onToggle.bind(this));
  }

  connectedCallback() {
    if (this.dataset.protectionOnly === 'true') {
      // protection is the only line left in the cart — clean it up
      this.removeProtection();
      return;
    }

    if (!this.hasAttribute('data-default-checked')) return;
    const checkbox = this.getCheckbox();
    if (!checkbox || checkbox.checked) return;

    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem('shipping-protection-dismissed') === '1';
    } catch (e) {
      // ignore
    }

    if (!dismissed) {
      checkbox.checked = true;
      this.addProtection();
    }
  }

  getCheckbox() {
    return this.querySelector('input[type="checkbox"]');
  }

  onToggle(event) {
    if (event.target !== this.getCheckbox()) return;

    if (event.target.checked) {
      try {
        sessionStorage.removeItem('shipping-protection-dismissed');
      } catch (e) {
        // ignore
      }
      this.addProtection();
    } else {
      // remember the opt-out so a default-checked setup doesn't re-add it
      try {
        sessionStorage.setItem('shipping-protection-dismissed', '1');
      } catch (e) {
        // ignore
      }
      this.removeProtection();
    }
  }

  getSectionsToRender() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems || typeof cartItems.getSectionsToRender !== 'function') return [];
    return cartItems.getSectionsToRender();
  }

  addProtection() {
    const body = JSON.stringify({
      items: [{ id: parseInt(this.dataset.variantId, 10), quantity: 1 }],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    this.performRequest(routes.cart_add_url, body);
  }

  removeProtection() {
    const updates = {};
    updates[this.dataset.variantId] = 0;
    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    this.performRequest(routes.cart_update_url, body);
  }

  performRequest(url, body) {
    const checkbox = this.getCheckbox();
    if (checkbox) checkbox.disabled = true;

    fetch(url, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => {
        if (state.status && state.status !== 200) throw new Error(state.description);
        this.renderSections(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection' });
      })
      .catch(() => {
        const box = this.getCheckbox();
        if (box) box.checked = !box.checked;
      })
      .finally(() => {
        const box = this.getCheckbox();
        if (box) box.disabled = false;
      });
  }

  renderSections(state) {
    if (!state.sections) return;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      const sectionHTML = state.sections[section.section];
      if (!container || !sectionHTML) return;

      const target = container.querySelector(section.selector) || container;
      const source = new DOMParser().parseFromString(sectionHTML, 'text/html').querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });

    // update.js responses include item_count; keep the empty-cart state in sync
    if (typeof state.item_count === 'number') {
      const cartItems = document.querySelector('cart-items');
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartItems) cartItems.classList.toggle('is-empty', state.item_count === 0);
      if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);
    }
  }
}

customElements.define('shipping-protection', ShippingProtection);
